module.exports = __webpack_public_path__ + "img/97.043538cd.jpg";